export var IPublicEnumPluginRegisterLevel = /*#__PURE__*/function (IPublicEnumPluginRegisterLevel) {
  IPublicEnumPluginRegisterLevel["Default"] = "default";
  IPublicEnumPluginRegisterLevel["Workspace"] = "workspace";
  IPublicEnumPluginRegisterLevel["Resource"] = "resource";
  IPublicEnumPluginRegisterLevel["EditorView"] = "editorView";
  return IPublicEnumPluginRegisterLevel;
}({});